<template>
  <div :class="['price-wrapper', bindMyClass]" :style="{ color: allColor }">
    <!-- 俄罗斯货币符号放在数字后 -->
    <template v-if="SymbolInAfter">
      <span
        :id="triggerCountup ? 'pay-price' : ''"
        class="real-price before-symbol"
      >
        <template v-if="isRuPubgm">
          {{ displayInfo.price }}
        </template>
        <template v-else>
          {{ displayInfo.price | formatMoney(needHandle) }}{{ ' ' }}
        </template>
      </span>
      <template>
        <img
          class="k-coin afterMoney"
          v-if="isKwalletSelected && allowShowKcoin"
          alt="k-coin"
          :src="require('@/assets/images/wallet/T-coin.png')"
        />
        <template v-else>
          {{ displayInfo.country }}
        </template>
      </template>
    </template>
    <template v-else>
      <template>
        <img
          class="k-coin beforeMoney"
          v-if="isKwalletSelected && allowShowKcoin"
          :src="require('@/assets/images/wallet/T-coin.png')"
        />
        <template v-else> {{ displayInfo.country }}</template>
      </template>
      <div
        :id="triggerCountup ? 'pay-price' : ''"
        class="real-price after-symbol"
      >
        {{ displayInfo.price | formatMoney(needHandle) }}
      </div>
      <div class="my-taxRate" v-if="isMyTaxRate">
        +{{ displayInfo.taxRate }} SST
      </div>
    </template>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import { moneyFormatRules } from '@/utils/moneyFormatRules'
  import { CountUp } from 'countup.js'
  import { taxPriceFunc } from '@/utils/mySstHack'
  export default {
    name: 'money-display',
    props: {
      allColor: {
        type: String,
        default: '',
      },
      taxRate: {
        type: Number,
        default: 0,
      },
      number: {
        type: Number,
        default: 0,
      },
      useConfig: {
        type: Boolean,
        default: false,
      },
      data: {
        type: Object,
        default: () => ({}),
      },
      payMethodName: {
        type: String,
        default: '',
      },
      allowShowKcoin: {
        type: Boolean,
        default: false,
      },
      triggerCountup: {
        type: Boolean,
        default: false,
      },
      needHandle: {
        type: Boolean,
        default: false,
      },
      isKwalletSelected: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        SymbolInAfter: false,
        isMyTaxRate: false, // 是否是马来<显示税率>
        displayInfo: {
          price: null, // 价格
          taxRate: null, // 税率 <目前只有马来>
          country: null, // 国家前缀
        },
      }
    },
    computed: {
      ...mapState(['region', 'currency', 'selectedPaymentInfo']),
      ...mapGetters(['isRuPubgm']),
      // 显示的价格
      calculatePrice() {
        return this.useConfig ? this.data.number : this.number
      },

      // 显示的国家前缀
      countryPrefix() {
        return this.useConfig ? this.data.currency : this.currency
      },

      // todo 兼容【马来】需要同时监听 <价格和税率> 在watch中使用
      priceTaxRate() {
        return {
          price: this.calculatePrice,
          taxRate: this.taxRate,
          country: this.countryPrefix,
          isKwallet: this.isKwalletSelected,
          istriggerCountup: this.triggerCountup,
        }
      },

      // 显示税率 绑定class
      bindMyClass() {
        return this.isMyTaxRate ? 'my-price-wrapper' : ''
      },
    },
    watch: {
      // todo [兼容]需要实时计算税前价格、监听三个值
      priceTaxRate: {
        handler(newVal = {}) {
          this.monitorPrice(newVal)
        },
        deep: true,
        immediate: true,
      },

      // 监听价格
      'displayInfo.price': {
        handler(price, oldPrice) {
          this.triggerCountup && this.realPayPriceHandle(price, oldPrice)
        },
      },
    },
    mounted() {
      this.SymbolInAfter = moneyFormatRules.SymbolInAfter
    },
    methods: {
      monitorPrice(newVal) {
        let { price, taxRate, country, isKwallet } = newVal
        const isMyCountry = this.getMyTaxRate(taxRate, isKwallet, price)

        // 马来单独计算
        if (isMyCountry && price > 0) {
          const { displayMoney, displayTrProce } = taxPriceFunc(price, taxRate)
          price = displayMoney
          taxRate = displayTrProce
        }
        this.displayInfo = {
          price,
          country,
          taxRate,
        }
      },

      // 国家是否为马来  显示【税前价 + 税率】
      getMyTaxRate(taxRate, isKwallet, price) {
        const region = this.region === 'my'
        const result = taxRate && region && !isKwallet && price > 0
        this.isMyTaxRate = result

        return result
      },

      // ! 挂载动效、改动价格的时候 注意
      realPayPriceHandle(realPayPrice, oldRealPayPrice) {
        // 渠道优惠的价格
        // https://github.com/inorganik/countUp.js
        const payPrice = realPayPrice < 0 ? 0 : realPayPrice
        const oldPayPrice = oldRealPayPrice < 0 ? 0 : oldRealPayPrice

        this.$nextTick(() => {
          const numAnim = new CountUp('pay-price', payPrice, {
            startVal: oldPayPrice,
            decimalPlaces: moneyFormatRules.decimalPlaces,
            duration: 1,
            decimal: moneyFormatRules.decimal,
            separator: moneyFormatRules.separator,
          })
          numAnim.start()
        })
      },
    },
  }
</script>
<style scoped lang="scss">
  .my-taxRate {
    font-size: 36px;
    padding-left: 15px;
  }
  .real-price {
    display: inline-block;
    &.after-symbol {
      padding-left: 10px;
    }
    &.before-symbol {
      padding-right: 10px;
    }
  }
  img.k-coin {
    object-fit: contain;
    width: 80px;
    height: 80px;
  }
  // 优惠券 bar TODO: 负号间距
  .counpon-container .coupon-line {
    .item-right.money .price-wrapper {
      margin-left: 10px;
    }
  }
  // 支付栏上方展开的优惠券
  .coupon-desc .price-wrapper {
    & > img.k-coin {
      width: 70px;
      height: 70px;
    }
  }
  div.price-wrapper {
    display: inline-flex;
    align-items: center;

    &.my-price-wrapper {
      display: flex;
      align-items: baseline;
    }
  }
  div.pay-price-wrapper {
    & > img.k-coin {
      width: 80px;
      height: 80px;
    }
  }
  div.original-price-wrapper {
    & > img.k-coin {
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
  }
  div.discount-price-wrapper {
    & > img.k-coin {
      width: 72px;
      height: 72px;
    }
  }
</style>
<style lang="scss" scoped>
  @media screen and (min-device-width: 1080px) {
    .my-taxRate {
      font-size: 14px;
      padding-left: 5px;
    }
  }
</style>
